// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2LUq1","footer":"ModalCreateQualiphyProcedure_footer__a1ycn","additionData":"ModalCreateQualiphyProcedure_additionData__3gxO7"};